import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FaCalendarAlt, FaArrowRight, FaPen } from 'react-icons/fa';
import { API_BASE } from '../api';
import "../css/styles.css";

const BlogList = () => {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [user, setUser] = useState(() => JSON.parse(localStorage.getItem("nyatwende_user") || "null"));

  useEffect(() => {
    fetch(`${API_BASE}/api/blogs`)
      .then(res => res.json())
      .then(data => {
        setBlogs(data);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, []);

  // Listen for auth changes
  useEffect(() => {
    const onAuth = () => setUser(JSON.parse(localStorage.getItem("nyatwende_user") || "null"));
    window.addEventListener("nyatwende_auth_change", onAuth);
    return () => window.removeEventListener("nyatwende_auth_change", onAuth);
  }, []);

  const featured = blogs.find(b => b.is_featured) || blogs[0];
  const rest = blogs.filter(b => b !== featured);

  // Parse multiple image URLs safely (Cloudinary URLs contain commas in params)
  const getFirstImage = (imageStr) => {
    if (!imageStr) return null;
    // Split on "https://" to find multiple URLs, rejoin the first one
    const parts = imageStr.split("https://").filter(Boolean);
    return parts.length > 0 ? "https://" + parts[0].replace(/,\s*$/, "") : null;
  };

  const formatDate = (dateStr) => {
    const d = new Date(dateStr);
    return d.toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });
  };

  if (loading) {
    return (
      <div className="blog-page">
        <section className="blog-hero">
          <div className="blog-hero-overlay" />
          <div className="blog-hero-content">
            <p className="blog-hero-label">Our Stories</p>
            <h1>Safari Journal</h1>
            <p className="blog-hero-sub">Loading stories...</p>
          </div>
        </section>
      </div>
    );
  }

  return (
    <div className="blog-page">
      {/* Hero */}
      <section className="blog-hero">
        <div className="blog-hero-overlay" />
        <div className="blog-hero-content">
          <p className="blog-hero-label">Our Stories</p>
          <h1>Safari Journal</h1>
          <p className="blog-hero-sub">Travel stories, tips &amp; inspiration from the heart of East Africa</p>
          {user && (
            <Link to="/write" className="hero-cta primary" style={{ marginTop: "1rem", display: "inline-flex", alignItems: "center", gap: "0.5rem" }}>
              <FaPen /> Write a Blog
            </Link>
          )}
        </div>
      </section>

      {/* Featured Post */}
      {featured && (
        <section className="blog-featured-section">
          <div className="blog-section-header">
            <h2>Featured Story</h2>
            <div className="blog-section-line" />
          </div>
          <Link to={featured.route || `/blog/${featured.slug || featured.id}`} className="blog-featured-card">
            <div className="blog-featured-img-wrap">
              {getFirstImage(featured.image) ? <img src={getFirstImage(featured.image)} alt={featured.title} /> : <div className="blog-img-placeholder" />}
              <div className="blog-featured-badge">Featured</div>
            </div>
            <div className="blog-featured-info">
              <span className="blog-date"><FaCalendarAlt /> {formatDate(featured.created_at)}</span>
              <h3>{featured.title}</h3>
              <p>{featured.description?.length > 150 ? featured.description.substring(0, 150) + "..." : featured.description}</p>
              <span className="blog-read-link">Read Full Story <FaArrowRight /></span>
            </div>
          </Link>
        </section>
      )}

      {/* All Posts Grid */}
      <section className="blog-grid-section">
        <div className="blog-section-header">
          <h2>All Stories</h2>
          <div className="blog-section-line" />
        </div>
        <div className="blog-grid">
          {(rest.length > 0 ? rest : blogs).map(blog => (
            <Link to={blog.route || `/blog/${blog.slug || blog.id}`} key={blog.id} className="blog-grid-card">
              <div className="blog-grid-img-wrap">
                {getFirstImage(blog.image) ? <img src={getFirstImage(blog.image)} alt={blog.title} /> : <div className="blog-img-placeholder" />}
                <div className="blog-grid-overlay" />
              </div>
              <div className="blog-grid-body">
                <span className="blog-date"><FaCalendarAlt /> {formatDate(blog.created_at)}</span>
                <h3>{blog.title}</h3>
                <p>{blog.description?.length > 120 ? blog.description.substring(0, 120) + "..." : blog.description}</p>
                <span className="blog-read-link">Read More <FaArrowRight /></span>
              </div>
            </Link>
          ))}
        </div>
      </section>
    </div>
  );
};

export default BlogList;
